"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentSearchFacetType;
(function (DocumentSearchFacetType) {
    DocumentSearchFacetType["filename"] = "DOCUMENT_PROPERTY_FILENAME";
    DocumentSearchFacetType["title"] = "DOCUMENT_PROPERTY_TITLE";
    DocumentSearchFacetType["culture"] = "DOCUMENT_PROPERTY_CULTURE_CODE";
    DocumentSearchFacetType["range"] = "RANGE";
    DocumentSearchFacetType["meta"] = "META";
    DocumentSearchFacetType["fund"] = "FUND";
    DocumentSearchFacetType["account"] = "ACCT";
    DocumentSearchFacetType["class"] = "CLSS";
})(DocumentSearchFacetType = exports.DocumentSearchFacetType || (exports.DocumentSearchFacetType = {}));
//# sourceMappingURL=DocumentSearchFacetType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/models/api/document/DocumentSearchFacetType.js
// module id = 758
// module chunks = 1